var map = {
	"./brand-logos/brand_logo_en.svg": 68951,
	"./brand-logos/brand_logo_kz.svg": 34141,
	"./brand-logos/brand_logo_ru.svg": 70241,
	"./brand-logos/logo_en_pink+white.svg": 79554,
	"./calc.svg": 33360,
	"./computer-mouse-middle.svg": 7924,
	"./computer-mouse-right.svg": 56763,
	"./copied.svg": 64891,
	"./copy.svg": 65072,
	"./eye.svg": 98978,
	"./geotar/bookmark.svg": 6802,
	"./geotar/brain.svg": 70838,
	"./geotar/cap.svg": 69650,
	"./geotar/chart.svg": 43422,
	"./geotar/check.svg": 7130,
	"./geotar/doctor.svg": 80155,
	"./geotar/magnifier.svg": 55542,
	"./geotar/shield.svg": 38817,
	"./home-banner/logo.svg": 88277,
	"./home-bg-mobile.svg": 9809,
	"./home/partner-23.svg": 8971,
	"./icons/checkCircleGrey.svg": 33307,
	"./icons/checkCircleRed.svg": 62471,
	"./icons/crossCircleRed.svg": 47303,
	"./icons/subscriber.svg": 92400,
	"./icons/unlim.svg": 28547,
	"./icons/user.svg": 21755,
	"./lock.svg": 97026,
	"./logo_care.svg": 77246,
	"./logo_care_big1.svg": 78374,
	"./mobile-menu/AI.svg": 93708,
	"./mobile-menu/edu.svg": 25402,
	"./mobile-menu/profile.svg": 44257,
	"./notifyIcons/error.svg": 20241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;